// https://github.com/carlsednaoui/add-to-calendar-buttons

var MS_IN_MINUTES = 60 * 1000;

  var formatTime = function(date, utc = true, strip = true) {
      var dateLocal = date.getFullYear() + '-' + String(date.getMonth()+1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0') + 'T' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0') + ':' + String(date.getSeconds()).padStart(2, '0');
      var dateFormatted = (utc ? date.toISOString() : dateLocal);
      if (strip) dateFormatted = dateFormatted.replace(/-|:|\.\d+/g, '');

      return dateFormatted;
  };

  var calculateEndTime = function(event, utc = true, strip = true) {
      var endTime = event.end ? event.end : new Date(event.start.getTime() + (event.duration * MS_IN_MINUTES));
      endTime = formatTime(endTime, utc, strip);

      return endTime;
  };

  var calendarGenerators = {
    google: function(event) {
      var startTime = formatTime(event.start);
      var endTime = calculateEndTime(event);

      var href = [
        'https://www.google.com/calendar/render',
        '?action=TEMPLATE',
        '&text=' + encodeURIComponent(event.title || ''),
        '&dates=' + (startTime || ''),
        '/' + (endTime || ''),
        '&details=' + encodeURIComponent(event.description || ''),
        '&location=' + (event.location || ''),
      ].join('');
      return '<a class="icon-google" target="_blank" href="' + href + '">Google <span class="online">(online)</span></a>';
    },

    yahoo: function(event) {
      var eventDuration = event.end ?
        ((event.end.getTime() - event.start.getTime())/ MS_IN_MINUTES) :
        event.duration;

      // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
      var yahooHourDuration = eventDuration < 600 ?
        '0' + Math.floor((eventDuration / 60)) :
        Math.floor((eventDuration / 60)) + '';

      var yahooMinuteDuration = eventDuration % 60 < 10 ?
        '0' + eventDuration % 60 :
        eventDuration % 60 + '';

      var yahooEventDuration = yahooHourDuration + yahooMinuteDuration;

      // Remove timezone from event time
      var st = formatTime(new Date(event.start), false) || '';

      var href = [
        'https://calendar.yahoo.com/?v=60&view=d&type=20',
        '&title=' + encodeURIComponent(event.title || ''),
        '&st=' + st,
        '&dur=' + (yahooEventDuration || ''),
        '&desc=' + encodeURIComponent(event.description || ''),
        '&in_loc=' + (event.location || '')
      ].join('');

      return '<a class="icon-yahoo" target="_blank" href="' +
        href + '">Yahoo! <span class="online">(online)</span></a>';
    },

    outlookcom: function(event) {
        var startTime = event.start.toISOString();
        var endTime = calculateEndTime(event, true, false);

        var description = (event.description || '');
        if (description) description = description.replace("\n", '<br>');
        var href = [
                'https://outlook.live.com/calendar/deeplink/compose?path=/calendar/action/compose&rru=addevent' +
                '&startdt=' + (startTime || ''),
                '&enddt=' + (endTime || ''),
                '&subject=' + encodeURIComponent(event.title || ''),
                '&body=' + encodeURIComponent(description),
                // '&location=' + (event.location || ''),
            ].join('');

        return '<a class="icon-outlook-com" target="_blank" href="' + href + '">Outlook <span class="online">(online)</span></a>';
    },

    ics: function(event, eClass, calendarName) {
      var startTime = formatTime(event.start);
      var endTime = calculateEndTime(event);

      // var href = 'data:text/calendar;charset=utf8,' + [
      //       'BEGIN:VCALENDAR',
      //       'VERSION:2.0',
      //       'BEGIN:VEVENT',
      //       'URL:' + (event.url || ''),
      //       'DTSTART:' + (startTime || ''),
      //       'DTEND:' + (endTime || ''),
      //       'SUMMARY:' + (event.title || ''),
      //       'DESCRIPTION:' + (event.description.replace("\n", ' - ') || ''),
      //       'LOCATION:' + (event.location || ''),
      //       'END:VEVENT',
      //       'END:VCALENDAR'
      //   ].join('\n');

      var href = event.downloadUrl;

      return '<a class="' + eClass + '" target="_blank" href="' + href + '">' + calendarName + '</a>';
    },

    ical: function(event) {
      return this.ics(event, 'icon-apple', 'Apple');
    },

    outlook: function(event) {
      return this.ics(event, 'icon-outlook', 'Outlook');
    }
  };

  var generateCalendars = function(event) {
    return {
      google: calendarGenerators.google(event),
      yahoo: calendarGenerators.yahoo(event),
      ical: calendarGenerators.ical(event),
      outlook: calendarGenerators.outlook(event),
      outlookcom: calendarGenerators.outlookcom(event)
    };
  };

  // Make sure we have the necessary event data, such as start time and event duration
  var validParams = function(params) {
    return params.data !== undefined && params.data.start !== undefined &&
      (params.data.end !== undefined || params.data.duration !== undefined);
  };

  var generateMarkup = function(calendars, clazz, calendarId) {
    var result = document.createElement('div');

    Object.keys(calendars).forEach(function(services) {
      result.innerHTML += calendars[services];
    });

    result.className = 'hpa-calendar-items';
    if (clazz !== undefined) {
      result.className += (' ' + clazz);
    }

    result.id = calendarId;
    return result;
  };

  var getClass = function(params) {
    if (params.options && params.options.class) {
      return params.options.class;
    }
  };

  var getOrGenerateCalendarId = function(params) {
    return params.options && params.options.id ?
      params.options.id :
      Math.floor(Math.random() * 1000000); // Generate a 6-digit random ID
  };

  module.exports = function(params) {
    if (!validParams(params)) {
      console.log('Event details missing.');
      return;
    }

    return generateMarkup(generateCalendars(params.data),
                          getClass(params),
                          getOrGenerateCalendarId(params));
  };



// WEBPACK FOOTER //
// ./js/lib/ouical.js